// Angular
import { NgModule } from '@angular/core';
import { CommonModule, NgOptimizedImage } from '@angular/common';
// Bootstrap
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
// Translate
import { TranslateModule } from '@ngx-translate/core';
// Medsurf Lib
import { MedsurfCommonModule } from '../common/medsurf-common.module';
// Components
import { ChapterSlideComponent } from "./chapter-slide.component";
import { ChapterModule } from "../chapter/chapter.module";
import { SlideModule } from "../slide/slide.module";

@NgModule({
  imports: [
    // Angular
    CommonModule,
    NgOptimizedImage,
    // Bootstrap
    NgbModule,
    // Translate
    TranslateModule.forChild(),
    // Modules
    MedsurfCommonModule,
    ChapterModule,
    SlideModule,
  ],
  declarations: [
    // Components
    ChapterSlideComponent
  ]
})
export class ChapterSlideModule {
}
